import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import api from '../../services/api';
import { StatCard, LoadingSpinner, StatusBadge } from '../../components/UI';
import { format } from 'date-fns';

export default function DeptDashboard() {
  const { user, role } = useSelector(s => s.auth);
  const [stats, setStats] = useState(null);
  const [recent, setRecent] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      api.get('/dashboard/stats'),
      api.get('/dept/applications?limit=5'),
    ]).then(([s, a]) => {
      setStats(s.stats);
      setRecent(a.applications?.slice(0, 5) || []);
    }).finally(() => setLoading(false));
  }, []);

  if (loading) return <LoadingSpinner size="lg" className="py-20" />;

  return (
    <div className="space-y-6">
      <div className="rounded-2xl text-white p-6 relative overflow-hidden"
        style={{ background: 'linear-gradient(135deg, #1a4731 0%, #276749 100%)' }}>
        <h2 className="text-xl font-bold mb-1">Welcome, {user?.name}! 👋</h2>
        <p className="text-green-100 text-sm">{user?.dept_name} • {role === 'final_dept' ? 'Final Approval Department' : 'Related Department'}</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        <StatCard title="Total" value={stats?.total} icon="📋" color="blue" />
        <StatCard title="Pending" value={stats?.pending} icon="⏳" color="yellow" />
        <StatCard title="Approved" value={stats?.approved} icon="✅" color="green" />
        <StatCard title="Rejected" value={stats?.rejected} icon="❌" color="red" />
        <StatCard title="Objection" value={stats?.objection} icon="⚠️" color="orange" />
        <StatCard title="Today" value={stats?.today} icon="📅" color="purple" />
      </div>

      <div className="card">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-gray-800">Pending Applications</h3>
          <Link to="/dept/applications" className="text-sm text-blue-600 hover:underline">View All</Link>
        </div>
        {recent.length === 0 ? (
          <p className="text-center py-8 text-gray-400">No pending applications</p>
        ) : (
          <div className="overflow-x-auto">
            <table className="data-table">
              <thead>
                <tr>
                  <th>Application No</th><th>NOC Type</th><th>Applicant</th><th>Mobile</th><th>Status</th><th>Date</th><th>Action</th>
                </tr>
              </thead>
              <tbody>
                {recent.map(app => (
                  <tr key={app.id}>
                    <td className="font-mono text-xs">{app.application_no}</td>
                    <td>{app.noc_name}</td>
                    <td>{app.user_name}</td>
                    <td>{app.mobile}</td>
                    <td><StatusBadge status={app.status} /></td>
                    <td className="text-xs">{app.submitted_at ? format(new Date(app.submitted_at), 'dd/MM/yyyy') : '-'}</td>
                    <td>
                      <Link to={`/dept/applications/${app.id}`} className="text-blue-600 hover:underline text-xs font-medium">View →</Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
